export default __webpack_public_path__ + "static/media/DJ.206d2d77.svg";